var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.499,
    height: 25.5,
    viewBox: "0 0 25.499 25.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-filled",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M0,0H25.5V25.5H0Z",
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M21.062,6a1.063,1.063,0,0,1,.124,2.118l-.124.007h-.086L20,19.813a3.188,3.188,0,0,1-3,3.182L16.812,23h-8.5a3.173,3.173,0,0,1-3.179-2.922L5.128,19.9,4.147,8.125H4.062a1.063,1.063,0,0,1-.124-2.118L4.062,6h17Z",
    transform: "translate(0.187 0.375)",
    fill: "#ff8a8a",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M14.375,2A2.125,2.125,0,0,1,16.5,4.125a1.062,1.062,0,0,1-2.118.124l-.007-.124h-4.25l-.007.124A1.062,1.062,0,0,1,8,4.125a2.125,2.125,0,0,1,1.966-2.12L10.125,2Z",
    transform: "translate(0.5 0.125)",
    fill: "#ff8a8a",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFilled);
export default __webpack_public_path__ + "static/media/trash-filled.4f96497d561b4ac8c198b9a09556b60b.svg";
export { ForwardRef as ReactComponent };